const doc = [({"da":({"js":({"admin":({"highscore_communes":({"table":({"the_commune_was_removed_from_the_highscore":"Kommunen blev fjernet fra highscoren"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;